var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCoolMath)?_c('v-btn',{staticClass:"white--text mb-2",attrs:{"block":"","color":_vm.$colors.blue},on:{"click":_vm.playPastPuzzles}},[_vm._v(" Play More Puzzles ")]):_c('v-btn',{staticClass:"white--text mb-2",attrs:{"block":"","color":_vm.$colors.blue},on:{"click":_vm.playPastPuzzles}},[_vm._v(" Play Past Puzzles ")])
}
var staticRenderFns = []

export { render, staticRenderFns }